import { Component, DestroyRef, ElementRef, effect, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NetworkStatusService } from '../../../core/services/network-status.service';

@Component({
  selector: 'app-offline-banner',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './offline-banner.component.html',
  styleUrl: './offline-banner.component.css',
})
export class OfflineBannerComponent {
  readonly networkStatus = inject(NetworkStatusService);
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

  constructor() {
    // The banner sits above the app shell, which is sized to the viewport; publish its height so
    // the shell (and the fixed sidebar) make room for it instead of being pushed partly off screen.
    effect((onCleanup) => {
      const online = this.networkStatus.isOnline();
      const el = this.host.nativeElement;
      const publish = () =>
        document.body.style.setProperty(
          '--offline-banner-height',
          online ? '0px' : `${Math.ceil(el.getBoundingClientRect().height)}px`
        );
      publish();
      if (online || typeof ResizeObserver === 'undefined') {
        return;
      }
      const observer = new ResizeObserver(publish);
      observer.observe(el);
      onCleanup(() => observer.disconnect());
    });

    inject(DestroyRef).onDestroy(() =>
      document.body.style.removeProperty('--offline-banner-height')
    );
  }
}
